/**
 * Branch Map — Lazy-loads Leaflet.js and initialises map
 * Only loaded on branch detail pages via branch-detail.liquid
 */
(function () {
  'use strict';

  var LEAFLET_CSS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
  var LEAFLET_JS = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
  var TILE_URL = 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png';
  var TILE_ATTR = '&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a> &copy; <a href="https://carto.com/">CARTO</a>';

  var mapEl = document.getElementById('branch-map');
  if (!mapEl) return;

  var lat = parseFloat(mapEl.dataset.lat);
  var lng = parseFloat(mapEl.dataset.lng);
  var name = mapEl.dataset.name || 'Branch';
  var resetBtn = document.querySelector('[data-branch-map-reset]');

  if (isNaN(lat) || isNaN(lng)) return;

  function loadCSS(href) {
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  }

  function loadJS(src, callback) {
    var script = document.createElement('script');
    script.src = src;
    script.onload = callback;
    document.head.appendChild(script);
  }

  function initMap() {
    var loadingEl = mapEl.querySelector('.branch-detail__map-loading');
    if (loadingEl) loadingEl.remove();

    var map = L.map(mapEl, {
      scrollWheelZoom: false,
      attributionControl: true
    }).setView([lat, lng], 15);

    L.tileLayer(TILE_URL, {
      attribution: TILE_ATTR,
      maxZoom: 19
    }).addTo(map);

    var marker = L.marker([lat, lng])
      .addTo(map)
      .bindPopup('<strong>' + name + '</strong>', {
        autoPan: false,
        keepInView: false
      })
      .openPopup();

    function centreMap(animate) {
      var branchPoint = L.latLng(lat, lng);
      map.invalidateSize({ pan: false });
      map.setView(branchPoint, 15, { animate: Boolean(animate), duration: 0.35 });
      marker.openPopup();
    }

    window.setTimeout(function () {
      centreMap(false);
    }, 150);

    window.addEventListener('resize', function () {
      centreMap(false);
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        centreMap(true);
      });
    }
  }

  // Lazy-load: use IntersectionObserver if available, else load immediately
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting) {
        observer.disconnect();
        loadCSS(LEAFLET_CSS);
        loadJS(LEAFLET_JS, initMap);
      }
    }, { rootMargin: '200px' });
    observer.observe(mapEl);
  } else {
    loadCSS(LEAFLET_CSS);
    loadJS(LEAFLET_JS, initMap);
  }
})();
